import styled from 'styled-components';

export const Content = styled.div`
  margin-bottom: 24px;
`;

export const Description = styled.div`
  font-style: italic;
  margin-bottom: 24px;
`;

export const ButtonGrid = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;

  button {
    max-width: 120px;
  }
`;

export const CheckboxItem = styled.li`
  display: flex;
  margin: 15px 0px;

  label {
    cursor: pointer;
    padding: 0 16px;
  }
`;

export const TestContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  color: ${({ theme }) => theme.colors.grey6};
  border: 1px solid;
  border-color: ${({ theme }) => theme.colors.grey3};
  border-radius: 16px;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
  h4 {
    color: ${({ theme }) => theme.colors.grey5};
    margin-top: 0;
    font-size: 14px;
  }
`;
